// costOfSalesContdReducer init state months

export const serverCostMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const concurrentAmountMonths = {
  0: 350,
  1: 350,
  2: 350,
  3: 350,
  4: 350,
  5: 350,
  6: 350,
  7: 350,
  8: 350,
  9: 350,
  10: 350,
  11: 350,
  12: 350,
  13: 350,
  14: 350,
  15: 350,
  16: 350,
  17: 350,
  18: 350,
  19: 350,
  20: 350,
  21: 350,
  22: 350,
  23: 350,
  24: 350,
  25: 350,
  26: 350,
  27: 350,
  28: 350,
  29: 350,
  30: 350,
  31: 350,
  32: 350,
  33: 350,
  34: 350,
  35: 350,
  36: 350,
};

export const concurrentRatioKeyMonths = {
  0: 1.5,
  1: 1.5,
  2: 1.5,
  3: 1.5,
  4: 1.5,
  5: 1.5,
  6: 1.5,
  7: 1.5,
  8: 1.5,
  9: 1.5,
  10: 1.5,
  11: 1.5,
  12: 1.5,
  13: 1.5,
  14: 1.5,
  15: 1.5,
  16: 1.5,
  17: 1.5,
  18: 1.5,
  19: 1.5,
  20: 1.5,
  21: 1.5,
  22: 1.5,
  23: 1.5,
  24: 1.5,
  25: 1.5,
  26: 1.5,
  27: 1.5,
  28: 1.5,
  29: 1.5,
  30: 1.5,
  31: 1.5,
  32: 1.5,
  33: 1.5,
  34: 1.5,
  35: 1.5,
  36: 1.5,
};

export const numberOfConcurrentMonths = {
  0: 2000,
  1: 2000,
  2: 2000,
  3: 2000,
  4: 2000,
  5: 2000,
  6: 2000,
  7: 2000,
  8: 2000,
  9: 2000,
  10: 2000,
  11: 2000,
  12: 2000,
  13: 2000,
  14: 2000,
  15: 2000,
  16: 2000,
  17: 2000,
  18: 2000,
  19: 2000,
  20: 2000,
  21: 2000,
  22: 2000,
  23: 2000,
  24: 2000,
  25: 2000,
  26: 2000,
  27: 2000,
  28: 2000,
  29: 2000,
  30: 2000,
  31: 2000,
  32: 2000,
  33: 2000,
  34: 2000,
  35: 2000,
  36: 2000,
};

export const numberOfAvgCumMembersMonth = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const fixedCostKeyMonth = {
  0: 1000,
  1: 1000,
  2: 1000,
  3: 1000,
  4: 1000,
  5: 1000,
  6: 1000,
  7: 1000,
  8: 1000,
  9: 1000,
  10: 1000,
  11: 1000,
  12: 1000,
  13: 1000,
  14: 1000,
  15: 1000,
  16: 1000,
  17: 1000,
  18: 1000,
  19: 1000,
  20: 1000,
  21: 1000,
  22: 1000,
  23: 1000,
  24: 1000,
  25: 1000,
  26: 1000,
  27: 1000,
  28: 1000,
  29: 1000,
  30: 1000,
  31: 1000,
  32: 1000,
  33: 1000,
  34: 1000,
  35: 1000,
  36: 1000,
};

// costOfSalesReducer init state

export const contentProductionKeyMonth = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const writtenContentKeyMonth = {
  0: 1000,
  1: 1000,
  2: 1250,
  3: 1250,
  4: 1250,
  6: 1250,
  5: 1250,
  7: 1250,
  8: 1250,
  9: 1250,
  10: 1250,
  11: 1250,
  12: 1250,
  13: 1250,
  14: 1250,
  15: 1250,
  16: 1250,
  17: 1250,
  18: 1250,
  19: 1250,
  20: 1250,
  21: 1250,
  22: 1250,
  23: 1250,
  24: 1250,
  25: 1250,
  26: 1250,
  27: 1250,
  28: 1250,
  29: 1250,
  30: 1250,
  31: 1250,
  32: 1250,
  33: 1250,
  34: 1250,
  35: 1250,
  36: 1250,
};

export const studioKeyMonth = {
  0: 500,
  1: 500,
  2: 500,
  3: 600,
  4: 600,
  5: 600,
  6: 600,
  7: 600,
  8: 600,
  9: 600,
  10: 600,
  11: 600,
  12: 600,
  13: 600,
  14: 600,
  15: 600,
  16: 600,
  17: 600,
  18: 600,
  19: 600,
  20: 600,
  21: 600,
  22: 600,
  23: 600,
  24: 600,
  25: 600,
  26: 600,
  27: 600,
  28: 600,
  29: 600,
  30: 600,
  31: 600,
  32: 600,
  33: 600,
  34: 600,
  35: 600,
  36: 600,
};

export const dubbingArtistsKeyMonth = {
  0: 250,
  1: 250,
  2: 250,
  3: 250,
  4: 300,
  5: 250,
  6: 250,
  7: 250,
  8: 250,
  9: 250,
  10: 250,
  11: 250,
  12: 250,
  13: 250,
  14: 250,
  15: 250,
  16: 250,
  17: 250,
  18: 250,
  19: 250,
  20: 250,
  21: 250,
  22: 250,
  23: 250,
  24: 250,
  25: 250,
  26: 250,
  27: 250,
  28: 250,
  29: 250,
  30: 250,
  31: 250,
  32: 250,
  33: 250,
  34: 250,
  35: 250,
  36: 250,
};

export const musicKey = {
  0: 350,
  1: 350,
  2: 350,
  3: 350,
  4: 350,
  5: 450,
  6: 450,
  7: 450,
  8: 450,
  9: 450,
  10: 450,
  11: 450,
  12: 450,
  13: 450,
  14: 450,
  15: 450,
  16: 450,
  17: 450,
  18: 450,
  19: 450,
  20: 450,
  21: 450,
  22: 450,
  23: 450,
  24: 450,
  25: 450,
  26: 450,
  27: 450,
  28: 450,
  29: 450,
  30: 450,
  31: 450,
  32: 450,
  33: 450,
  34: 450,
  35: 450,
  36: 450,
};

// generalAdministrativeExpensesReducer init state

export const gae_otherOperatingExpensesMonth = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const gae_legalKeyMonth = {
  0: 1250,
  1: 1250,
  2: 1250,
  3: 1250,
  4: 1250,
  5: 1250,
  6: 1250,
  7: 1250,
  8: 1250,
  9: 1250,
  10: 1250,
  11: 1250,
  12: 1250,
  13: 1250,
  14: 1250,
  15: 1250,
  16: 1250,
  17: 1250,
  18: 1250,
  19: 1250,
  20: 1250,
  21: 1250,
  22: 1250,
  23: 1250,
  24: 1250,
  25: 1250,
  26: 1250,
  27: 1250,
  28: 1250,
  29: 1250,
  30: 1250,
  31: 1250,
  32: 1250,
  33: 1250,
  34: 1250,
  35: 1250,
  36: 1250,
};

export const gae_accountingCPAMonth = {
  0: 1000,
  1: 1000,
  2: 1000,
  3: 1000,
  4: 1000,
  5: 1000,
  6: 1000,
  7: 1000,
  8: 1000,
  9: 1000,
  10: 1000,
  11: 1000,
  12: 1000,
  13: 1000,
  14: 1000,
  15: 1000,
  16: 1000,
  17: 1000,
  18: 1000,
  19: 1000,
  20: 1000,
  21: 1000,
  22: 1000,
  23: 1000,
  24: 1000,
  25: 1000,
  26: 1000,
  27: 1000,
  28: 1000,
  29: 1000,
  30: 1000,
  31: 1000,
  32: 1000,
  33: 1000,
  34: 1000,
  35: 1000,
  36: 1000,
};

export const gae_bookkeeperKeyMonth = {
  0: 750,
  1: 750,
  2: 750,
  3: 750,
  4: 750,
  5: 750,
  6: 750,
  7: 750,
  8: 750,
  9: 750,
  10: 750,
  11: 750,
  12: 750,
  13: 750,
  14: 750,
  15: 750,
  16: 750,
  17: 750,
  18: 750,
  19: 750,
  20: 750,
  21: 750,
  22: 750,
  23: 750,
  24: 750,
  25: 750,
  26: 750,
  27: 750,
  28: 750,
  29: 750,
  30: 750,
  31: 750,
  32: 750,
  33: 750,
  34: 750,
  35: 750,
  36: 750,
};

export const gae_researchAnalysisMonth = {
  0: 0,
  1: 0,
  2: 250,
  3: 500,
  4: 750,
  5: 1000,
  6: 1000,
  7: 1000,
  8: 1000,
  9: 1000,
  10: 1000,
  11: 1000,
  12: 1000,
  13: 1000,
  14: 1000,
  15: 1000,
  16: 1000,
  17: 1000,
  18: 1000,
  19: 1000,
  20: 1000,
  21: 1000,
  22: 1000,
  23: 1000,
  24: 1000,
  25: 1000,
  26: 1000,
  27: 1000,
  28: 1000,
  29: 1000,
  30: 1000,
  31: 1000,
  32: 1000,
  33: 1000,
  34: 1000,
  35: 1000,
  36: 1000,
};

export const gae_consultantsMonth = {
  0: 0,
  1: 500,
  2: 750,
  3: 1000,
  4: 1000,
  5: 1000,
  6: 1000,
  7: 1000,
  8: 1000,
  9: 1000,
  10: 1000,
  11: 1000,
  12: 1000,
  13: 1000,
  14: 1000,
  15: 1000,
  16: 1000,
  17: 1000,
  18: 1000,
  19: 1000,
  20: 1000,
  21: 1000,
  22: 1000,
  23: 1000,
  24: 1000,
  25: 1000,
  26: 1000,
  27: 1000,
  28: 1000,
  29: 1000,
  30: 1000,
  31: 1000,
  32: 1000,
  33: 1000,
  34: 1000,
  35: 1000,
  36: 1000,
};

export const gae_rentGeneralExpensesMonth = {
  0: 2000,
  1: 2000,
  2: 2200,
  3: 2400,
  4: 2500,
  5: 2700,
  6: 2700,
  7: 2700,
  8: 2700,
  9: 2700,
  10: 2700,
  11: 2700,
  12: 2700,
  13: 2700,
  14: 2700,
  15: 2700,
  16: 2700,
  17: 2700,
  18: 2700,
  19: 2700,
  20: 2700,
  21: 2700,
  22: 2700,
  23: 2700,
  24: 2700,
  25: 2700,
  26: 2700,
  27: 2700,
  28: 2700,
  29: 2700,
  30: 2700,
  31: 2700,
  32: 2700,
  33: 2700,
  34: 2700,
  35: 2700,
  36: 2700,
};

export const gae_fixedAssetMonth = {
  0: 400,
  1: 400,
  2: 400,
  3: 400,
  4: 400,
  5: 400,
  6: 400,
  7: 400,
  8: 400,
  9: 400,
  10: 400,
  11: 400,
  12: 400,
  13: 400,
  14: 400,
  15: 400,
  16: 400,
  17: 400,
  18: 400,
  19: 400,
  20: 400,
  21: 400,
  22: 400,
  23: 400,
  24: 400,
  25: 400,
  26: 400,
  27: 400,
  28: 400,
  29: 400,
  30: 400,
  31: 400,
  32: 400,
  33: 400,
  34: 400,
  35: 400,
  36: 400,
};

export const gae_educationExpensesMonth = {
  0: 350,
  1: 350,
  2: 350,
  3: 350,
  4: 350,
  5: 350,
  6: 350,
  7: 350,
  8: 350,
  9: 350,
  10: 350,
  11: 350,
  12: 350,
  13: 350,
  14: 350,
  15: 350,
  16: 350,
  17: 350,
  18: 350,
  19: 350,
  20: 350,
  21: 350,
  22: 350,
  23: 350,
  24: 350,
  25: 350,
  26: 350,
  27: 350,
  28: 350,
  29: 350,
  30: 350,
  31: 350,
  32: 350,
  33: 350,
  34: 350,
  35: 350,
  36: 350,
};

export const gae_emailSubscriptionsMonth = {
  0: 250,
  1: 250,
  2: 250,
  3: 250,
  4: 250,
  5: 250,
  6: 250,
  7: 250,
  8: 250,
  9: 250,
  10: 250,
  11: 250,
  12: 250,
  13: 250,
  14: 250,
  15: 250,
  16: 250,
  17: 250,
  18: 250,
  19: 250,
  20: 250,
  21: 250,
  22: 250,
  23: 250,
  24: 250,
  25: 250,
  26: 250,
  27: 250,
  28: 250,
  29: 250,
  30: 250,
  31: 250,
  32: 250,
  33: 250,
  34: 250,
  35: 250,
  36: 250,
};

// salesAndMarketingExpensesReducer

export const same_marketingExpensesMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const same_mediaBuyingMonths = {
  0: 300000,
  1: 300000,
  2: 300000,
  3: 300000,
  4: 300000,
  5: 300000,
  6: 300000,
  7: 300000,
  8: 300000,
  9: 300000,
  10: 300000,
  11: 300000,
  12: 300000,
  13: 300000,
  14: 300000,
  15: 300000,
  16: 300000,
  17: 300000,
  18: 300000,
  19: 300000,
  20: 300000,
  21: 300000,
  22: 300000,
  23: 300000,
  24: 300000,
  25: 300000,
  26: 300000,
  27: 300000,
  28: 300000,
  29: 300000,
  30: 300000,
  31: 300000,
  32: 300000,
  33: 300000,
  34: 300000,
  35: 300000,
  36: 300000,
};

export const same_ombaaMonths = {
  0: 1000,
  1: 1000,
  2: 1000,
  3: 1000,
  4: 1000,
  5: 1000,
  6: 1000,
  7: 1000,
  8: 1000,
  9: 1000,
  10: 1000,
  11: 1000,
  12: 1000,
  13: 1000,
  14: 1000,
  15: 1000,
  16: 1000,
  17: 1000,
  18: 1000,
  19: 1000,
  20: 1000,
  21: 1000,
  22: 1000,
  23: 1000,
  24: 1000,
  25: 1000,
  26: 1000,
  27: 1000,
  28: 1000,
  29: 1000,
  30: 1000,
  31: 1000,
  32: 1000,
  33: 1000,
  34: 1000,
  35: 1000,
  36: 1000,
};

export const same_seoMonths = {
  0: 250,
  1: 250,
  2: 250,
  3: 250,
  4: 250,
  5: 250,
  6: 250,
  7: 250,
  8: 250,
  9: 250,
  10: 250,
  11: 250,
  12: 250,
  13: 250,
  14: 250,
  15: 250,
  16: 250,
  17: 250,
  18: 250,
  19: 250,
  20: 250,
  21: 250,
  22: 250,
  23: 250,
  24: 250,
  25: 250,
  26: 250,
  27: 250,
  28: 250,
  29: 250,
  30: 250,
  31: 250,
  32: 250,
  33: 250,
  34: 250,
  35: 250,
  36: 250,
};

// advertisementExpensesReducer

export const ae_prOnOffInfluencerActivitiesMonths = {
  0: 5000,
  1: 5000,
  2: 5000,
  3: 5000,
  4: 5000,
  5: 5000,
  6: 5000,
  7: 5000,
  8: 5000,
  9: 5000,
  10: 5000,
  11: 5000,
  12: 5000,
  13: 5000,
  14: 5000,
  15: 5000,
  16: 5000,
  17: 5000,
  18: 5000,
  19: 5000,
  20: 5000,
  21: 5000,
  22: 5000,
  23: 5000,
  24: 5000,
  25: 5000,
  26: 5000,
  27: 5000,
  28: 5000,
  29: 5000,
  30: 5000,
  31: 5000,
  32: 5000,
  33: 5000,
  34: 5000,
  35: 5000,
  36: 5000,
};

// otherAdvertisementAndMarketingExpenseReducer

export const oame_analyticsAndEngagementTool = {
  0: 200,
  1: 200,
  2: 200,
  3: 200,
  4: 200,
  5: 200,
  6: 200,
  7: 200,
  8: 200,
  9: 200,
  10: 200,
  11: 200,
  12: 200,
  13: 200,
  14: 200,
  15: 200,
  16: 200,
  17: 200,
  18: 200,
  19: 200,
  20: 200,
  21: 200,
  22: 200,
  23: 200,
  24: 200,
  25: 200,
  26: 200,
  27: 200,
  28: 200,
  29: 200,
  30: 200,
  31: 200,
  32: 200,
  33: 200,
  34: 200,
  35: 200,
  36: 200,
};

export const oame_mailingMonth = {
  0: 75,
  1: 75,
  2: 75,
  3: 75,
  4: 75,
  5: 75,
  6: 75,
  7: 75,
  8: 75,
  9: 75,
  10: 75,
  11: 75,
  12: 75,
  13: 75,
  14: 75,
  15: 75,
  16: 75,
  17: 75,
  18: 75,
  19: 75,
  20: 75,
  21: 75,
  22: 75,
  23: 75,
  24: 75,
  25: 75,
  26: 75,
  27: 75,
  28: 75,
  29: 75,
  30: 75,
  31: 75,
  32: 75,
  33: 75,
  34: 75,
  35: 75,
  36: 75,
};
